import classNames from 'classnames';
import React from 'react';
import type { ProvisionType, UserType } from '../../graphql/generated/graphql';
import * as styles from './TeammateTypeLabel.module.scss';

const getLabel = (type: UserType | ProvisionType) => {
  switch (type) {
    case 'ADMIN':
      return 'Admin';
    case 'USER':
      return 'Standard User';
    case 'GUEST':
      return 'Guest';
    default:
      return null;
  }
};

interface TeammateTypeLabelProps {
  type?: UserType | ProvisionType | null;
  deactivated?: boolean;
}

const TeammateTypeLabel = ({ type, deactivated }: TeammateTypeLabelProps) => {
  if (deactivated || !type) {
    return <div />;
  }

  return (
    <div className={styles.label}>
      <div
        className={classNames(styles.indicator, {
          [styles.admin]: type === 'ADMIN',
          [styles.guest]: type === 'GUEST',
          [styles.user]: type === 'USER',
        })}
      />
      {getLabel(type)}
    </div>
  );
};

export default TeammateTypeLabel;
